/**
 * Created by lihanying on 2017/7/20.
 */
import React from 'react'
import { Modal, Row, Col, Checkbox, Input, TimePicker, Button } from 'antd'
import moment from 'moment'
export default class extends React.Component {
  state = {
    start_time: null,
    end_time: null,
  }

  onStartTime = (time, timeString) => {
    if (time) {
      this.setState({ start_time: timeString })
      sessionStorage.setItem('start_time', timeString)
    }
  }

  onEndTime = (time, timeString) => {
    if (time) {
      this.setState({ end_time: timeString })
      sessionStorage.setItem('end_time', timeString)
    }
  }

  range = (start, end) => {
    const result = []
    for (let i = start; i < end; i++) {
      result.push(i)
    }
    return result
  }

  disabledHours = () => {
    const { start_time } = this.state
    let hours
    if (start_time) {
      let h = start_time.slice(0, 2) //'01:09:00'=>01
      let m = start_time.slice(3, 5)
      hours = this.range(0, 60)
      if (m < 59) {
        hours.splice(+h, 24 - +h)
      } else {
        hours.splice(+h + 1, 24 - +h)
      }
    } else {
      hours = this.range(0, 60)
      hours.splice(23, 0)
    }
    return hours
  }

  disabledMinutes = (hou) => {
    const { start_time } = this.state
    let hours
    if (start_time) {
      let h = start_time.slice(0, 2)
      let m = start_time.slice(3, 5)
      if (h < hou) {
        hours = this.range(0, 60)
        hours.splice(0, 60)
      } else {
        hours = this.range(0, 60)
        hours.splice(+m + 1, 60 - (+m - 1))
      }
    } else {
      hours = this.range(0, 60)
      hours.splice(59, 0)
    }
    return hours
  }

  // 全选/取消全选星期
  selectAllWeek = () => {
    const weekDay = this.props.weekDay == undefined ? [] : this.props.weekDay
    if (weekDay.length != 7) {
      this.props.onChangeDay([0, 1, 2, 3, 4, 5, 6])
    }
    if (weekDay.length == 7) {
      this.props.onChangeDay([])
    }
  }

  render() {
    const { modal, tables } = this.props
    const weekDay = [
      {
        id: 0,
        day: '星期天',
      },
      {
        id: 1,
        day: '星期一',
      },
      {
        id: 2,
        day: '星期二',
      },
      {
        id: 3,
        day: '星期三',
      },
      {
        id: 4,
        day: '星期四',
      },
      {
        id: 5,
        day: '星期五',
      },
      {
        id: 6,
        day: '星期六',
      },
    ]
    return (
      <div>
        <Modal
          title="分时段收费设置"
          visible={modal}
          onOk={this.props.handleOk}
          onCancel={() => {
            this.props.onChangeDay([])
            this.props.handleCancel()
          }}
          width="800px"
        >
          <div className="gutter-example">
            <Row gutter={16}>
              {tables.map((item, idx) => {
                return (
                  <Col className="gutter-row" span={4} key={idx}>
                    <div className="gutter-box">{`${idx + 1}.${
                      item.name
                    }`}</div>
                  </Col>
                )
              })}
            </Row>
          </div>
          <div style={{ marginTop: '1rem' }}>
            <p>
              选择折扣日期:
              <Button
                type="primary"
                size="small"
                ghost
                style={{ marginLeft: '20px' }}
                onClick={this.selectAllWeek}
              >
                全选
              </Button>
            </p>
            <Checkbox.Group
              onChange={this.props.onChangeDay}
              value={this.props.weekDay}
            >
              <Row>
                {weekDay.map((item, idx) => {
                  return (
                    <Col span={8} key={idx}>
                      <Checkbox value={item.id}>{item.day}</Checkbox>
                    </Col>
                  )
                })}
              </Row>
            </Checkbox.Group>
          </div>
          <div style={{ marginTop: '1rem' }}>
            <span>请输入价格:</span>
            <Input
              size="large"
              style={{ width: '50%', marginLeft: '1.7rem' }}
              placeholder="该打折时段单价"
              onChange={(e) =>
                sessionStorage.setItem('time_price', e.target.value)
              }
            />
          </div>
          <div style={{ marginTop: '1rem' }}>
            <span>选择开始时间:</span>
            <TimePicker
              id="stime"
              onChange={this.onStartTime}
              format="HH:mm"
              defaultValue={moment('09:00', 'HH:mm')}
              style={{ marginLeft: '.9rem' }}
              value={
                this.state.start_time
                  ? moment(`${this.state.start_time}`, 'HH:mm')
                  : null
              }
            />
          </div>
          <div style={{ marginTop: '1rem' }}>
            <span>选择结束时间:</span>
            <TimePicker
              id="etime"
              onChange={this.onEndTime}
              format="HH:mm"
              defaultValue={moment('12:00', 'HH:mm')}
              style={{ marginLeft: '.9rem' }}
              value={
                this.state.end_time
                  ? moment(`${this.state.end_time}`, 'HH:mm')
                  : null
              }
              disabledHours={this.disabledHours}
              disabledMinutes={this.disabledMinutes}
            />
          </div>
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubTable/component/modalInterval.js